import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { Resource } from "@examspark/types";

import canvasClickExternalTool from "./lti-launch-instructions/canvas/canvas-click-external-tool.png";
import canvasGoToAssignments from "./lti-launch-instructions/canvas/canvas-go-to-assignments.png";

const Styled = styled.div`
  font-size: 1.3rem;
  font-family: "Lato";
`;
const Centered = styled.div`
  padding: 2rem 6rem;
  max-width: 70rem;
  margin: 0 auto;
`;

const Step = styled.div`
  margin-top: 3rem;
  position: relative;

  img {
    display: block;
    max-width: 100%;
    border-radius: 0.5rem;
    margin: 0.5rem 0;
  }

  &:first-child {
    margin-top: 0;
  }
`;

const StepNumber = styled.div`
  position: absolute;
  left: -4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  background-color: #006699;
  color: #fff;
  border-radius: 100%;
  text-align: center;
  padding: 0.4rem 0.5rem;
  margin: -0.3rem 0;
  font-size: 1.2rem;
`;

interface Props {
  examConfig: Resource;
  productName: string;
  platform?: "canvas" | "schoology";
}

const LaunchInstructions: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 2500);
    }
  }, [isCopied]);

  return (
    <Styled>
      <Centered>
        {props.platform === "canvas" ? (
          <>
            <Step>
              <StepNumber>1</StepNumber>
              In your Canvas course, go to <strong>Assignments</strong>, then{" "}
              <strong>+ Assignment</strong>
              <img
                alt="instructions-step-2"
                // src="/img/lti-launch-instructions/canvas/lti-canvas-assignments.png"
                src={canvasGoToAssignments}
              />
            </Step>
            <Step>
              <StepNumber>2</StepNumber>
              Enter your assignment details. Then, scroll to Submission Type,
              select <strong>External Tool</strong>, and click the Find button
              located near the field labelled{" "}
              <strong>Enter or find an External Tool URL</strong>.
              <img
                alt="instructions-step-3"
                src={canvasClickExternalTool}
                // src="/img/lti-launch-instructions/canvas/lti-canvas-assignment-create.png"
              />
            </Step>
            <Step>
              <StepNumber>3</StepNumber>
              Click <strong>{props.productName}</strong> to open the activity
              picker. Find this activity and click <strong>Assign</strong>.
            </Step>
            <Step>
              <StepNumber>4</StepNumber>
              Click <strong>Save</strong> (or <strong>Save & Publish</strong>)
              to create the assignment. The assignment will display in your
              students' assignments list.
            </Step>
          </>
        ) : (
          <>
            <Step>
              <StepNumber>1</StepNumber>
              In your Schoology course, click <strong>Materials</strong>, then{" "}
              <strong>Add Materials</strong>, then{" "}
              <strong>{props.productName}</strong>
              <img
                alt="insructions-step-1"
                src="/img/lti-launch-instructions/schoology/01-add-materials.png"
              />
            </Step>
            <Step>
              <StepNumber>2</StepNumber>
              Select the activity you wish to add to Schoology, then click{" "}
              <strong>Select</strong>.
              <img
                alt="insructions-step-2"
                src="/img/lti-launch-instructions/schoology/02-select-activity.png"
              />
            </Step>
            <Step>
              <StepNumber>3</StepNumber>
              To enable grading, click <strong>Edit</strong> for the new
              Material, then follow the steps below to enable scoring. .
              <img
                alt="insructions-step-3"
                src="/img/lti-launch-instructions/schoology/03-edit-activity.png"
              />
            </Step>
            <Step>
              <img
                alt="insructions-step-4"
                src="/img/lti-launch-instructions/schoology/04-edit-activity-form.png"
              />
            </Step>
          </>
        )}
      </Centered>
    </Styled>
  );
};

export default LaunchInstructions;
